const PREFIX = 'EMPLOYEES_PIN_'

export const SUBMITTING_GET_PERMISSIONS = `SUBMITTING_GET_PERMISSIONS`

export const EMPLOYEE_PIN_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`

export const EMPLOYEE_PIN_PIN_REQUEST = `${PREFIX}PIN_REQUEST`

export const EMPLOYEE_PIN_ON_SUBMIT_FORM = `${PREFIX}ON_SUBMIT_FORM`

export const EMPLOYEE_PIN_SET_SUBMITTING = `${PREFIX}SET_SUBMITTING`

export const EMPLOYEE_PIN_SET_ALLOWED_FIELDS = `${PREFIX}SET_ALLOWED_FIELDS`

export const EMPLOYEE_PIN_SHOW_SAVE_APP_PERMISSION_MODAL = `${PREFIX}SHOW_SAVE_APP_PERMISSION_MODAL`

export const EMPLYOEE_PIN_HIDE_SAVE_APP_PERMISSION_MODAL = `${PREFIX}HIDE_SAVE_APP_PERMISSION_MODAL`

export const EMPLOYEE_PIN_SET_CAN_ENABLE_PIN = `${PREFIX}SET_CAN_ENABLE_PIN`

export const EMPLOYEE_PIN_SET_SAVE_APP_PERMISSION_MODAL = `${PREFIX}SET_SAVE_APP_PERMISSION_MODAL`



// WEBPACK FOOTER //
// ./app/actions/employees/pin/constants.js